export const CATEGORIES = [
  "Politics",
  "Entertainment",
  "Sports",
  "Business",
  "Technology",
  "Security",
  "Education",
  "Health",
  "Trending",
  "Viral",
];

export const mockPosts = [
  {
    id: "1",
    title: "Breaking: Major Political Developments Shake the Nation",
    slug: "major-political-developments",
    excerpt: "In a dramatic turn of events, key political figures announced sweeping changes that could reshape the country's future for the next decade.",
    content: `<p>In a dramatic turn of events, key political figures announced sweeping changes that could reshape the country's future for the next decade. The announcement came after weeks of closed-door negotiations between top officials.</p>
    <p>Sources close to the matter revealed that the reforms will touch on healthcare, education, and economic policy. Citizens have reacted with a mixture of hope and skepticism, taking to social media to voice their opinions.</p>
    <p>Opposition leaders have called for an emergency session of parliament, arguing that the changes bypass democratic processes. Meanwhile, supporters argue that bold action is needed to address the mounting challenges facing the nation.</p>
    <p>Political analysts say this could be the most significant policy shift in a generation, with far-reaching consequences for ordinary citizens. The coming weeks will be critical as legislators debate the fine print of these proposals.</p>`,
    category: "Politics",
    imageUrl: "https://picsum.photos/seed/politics1/800/450",
    author: "Chidi Okonkwo",
    authorAvatar: "https://picsum.photos/seed/author1/80/80",
    timestamp: new Date("2026-06-14T08:00:00"),
    views: 12400,
    trending: true,
    viral: false,
  },
  {
    id: "2",
    title: "Nollywood Star Stuns Fans With Surprise Wedding Announcement",
    slug: "nollywood-star-surprise-wedding",
    excerpt: "Popular actress drops bombshell news on social media, sending fans into a frenzy with photos that have since gone viral across all platforms.",
    content: `<p>Popular actress dropped bombshell news on social media late Thursday night, sending fans into a frenzy with stunning photos that have since gone viral across all platforms.</p>
    <p>The actress, known for her roles in several blockbuster productions, shared a series of intimate photos with her partner of three years, announcing their secret nuptials.</p>
    <p>The wedding reportedly took place at a private venue with only close family and friends in attendance. Celebrity colleagues flooded the comments with congratulatory messages.</p>
    <p>The surprise announcement has sparked enormous discussion online, with fans expressing both excitement and surprise at the news. Many noted the couple had kept their relationship largely out of the public eye.</p>`,
    category: "Entertainment",
    imageUrl: "https://picsum.photos/seed/entertain1/800/450",
    author: "Amaka Eze",
    authorAvatar: "https://picsum.photos/seed/author2/80/80",
    timestamp: new Date("2026-06-15T10:30:00"),
    views: 34200,
    trending: true,
    viral: true,
  },
  {
    id: "3",
    title: "Super Eagles Secure Historic Qualification in Thrilling Match",
    slug: "super-eagles-historic-qualification",
    excerpt: "Nigeria's national football team produces a memorable performance to clinch their spot, with fans celebrating across the country.",
    content: `<p>Nigeria's national football team produced a memorable performance to clinch their spot in the tournament, with fans celebrating wildly across the country after the final whistle.</p>
    <p>The match, played in front of a packed stadium, saw the team come from behind to win 3-2 in what commentators are calling one of the most dramatic games in recent memory.</p>
    <p>The captain scored the winning goal in the dying minutes, sparking euphoric scenes both in the stadium and in cities across Nigeria. Streets were filled with jubilant fans waving flags and horns.</p>
    <p>The coach praised the team's resilience and fighting spirit, saying the victory was a testament to the hard work put in during weeks of intensive preparation.</p>`,
    category: "Sports",
    imageUrl: "https://picsum.photos/seed/sports1/800/450",
    author: "Emeka Nwosu",
    authorAvatar: "https://picsum.photos/seed/author3/80/80",
    timestamp: new Date("2026-06-13T18:00:00"),
    views: 28900,
    trending: true,
    viral: true,
  },
  {
    id: "4",
    title: "Tech Giant Announces $500M Investment in African Markets",
    slug: "tech-giant-africa-investment",
    excerpt: "Global technology company commits to building data centres and training programmes across multiple African countries in landmark deal.",
    content: `<p>A global technology company has announced a landmark $500 million investment across multiple African countries, committing to building data centres and launching extensive training programmes.</p>
    <p>The investment, described as the largest of its kind on the continent, will span five countries over the next three years. Local engineers and developers are expected to benefit from thousands of new job opportunities.</p>
    <p>The announcement was made at a major technology summit, drawing praise from government officials and business leaders who see it as a vote of confidence in Africa's digital future.</p>
    <p>Critics, however, urge caution, asking for clarity on profit repatriation and data sovereignty agreements. Negotiations are still ongoing on several key terms.</p>`,
    category: "Technology",
    imageUrl: "https://picsum.photos/seed/tech1/800/450",
    author: "Tunde Adeyemi",
    authorAvatar: "https://picsum.photos/seed/author4/80/80",
    timestamp: new Date("2026-06-12T14:00:00"),
    views: 9800,
    trending: false,
    viral: false,
  },
  {
    id: "5",
    title: "New Health Guidelines Released for Managing Stress in 2026",
    slug: "new-health-guidelines-stress-2026",
    excerpt: "Medical experts issue updated recommendations on lifestyle changes, mental health support, and preventative care for a healthier nation.",
    content: `<p>Medical experts have issued updated recommendations on lifestyle changes, mental health support, and preventative care as the country grapples with rising stress-related illnesses.</p>
    <p>The new guidelines emphasise the importance of regular physical activity, adequate sleep, and mindfulness practices. They also call for greater access to mental health services in both urban and rural communities.</p>
    <p>Healthcare practitioners are encouraged to screen patients more regularly for stress-related conditions and to adopt a more holistic approach to treatment plans.</p>
    <p>The guidelines have been welcomed by patient advocacy groups, who hope they will translate into concrete policy improvements and increased government funding for mental health programmes.</p>`,
    category: "Health",
    imageUrl: "https://picsum.photos/seed/health1/800/450",
    author: "Dr. Ngozi Adeola",
    authorAvatar: "https://picsum.photos/seed/author5/80/80",
    timestamp: new Date("2026-06-11T09:00:00"),
    views: 7600,
    trending: false,
    viral: false,
  },
  {
    id: "6",
    title: "Entrepreneur Builds Million-Dollar Business From Lagos Market Stall",
    slug: "entrepreneur-million-dollar-lagos-market",
    excerpt: "Inspiring story of a young woman who turned a modest market stall into a thriving e-commerce empire employing over 200 people.",
    content: `<p>In a story that has captured the imagination of millions, a young entrepreneur from Lagos has built a million-dollar business empire starting from a modest market stall she set up with just a small loan from her mother.</p>
    <p>Over seven years, she grew her business from selling handmade goods at a local market to running a thriving e-commerce platform that now employs over 200 people.</p>
    <p>Her journey has not been without challenges. She recalls sleepless nights, failed product launches, and moments of deep self-doubt. But she credits her community, mentors, and relentless curiosity with keeping her going.</p>
    <p>Now a sought-after speaker at business conferences, she is passionate about mentoring other young entrepreneurs, particularly women, who face systemic barriers to accessing capital and markets.</p>`,
    category: "Business",
    imageUrl: "https://picsum.photos/seed/business1/800/450",
    author: "Fatima Al-Hassan",
    authorAvatar: "https://picsum.photos/seed/author6/80/80",
    timestamp: new Date("2026-06-10T11:00:00"),
    views: 15300,
    trending: true,
    viral: false,
  },
  {
    id: "7",
    title: "Video Goes Viral: Man Proposes Using Holographic Technology",
    slug: "viral-holographic-proposal",
    excerpt: "A romantic proposal using cutting-edge holographic displays has taken the internet by storm, racking up millions of views in just 24 hours.",
    content: `<p>A romantic proposal using cutting-edge holographic display technology has taken the internet by storm, racking up tens of millions of views across social media platforms in just 24 hours.</p>
    <p>The video shows a man surprising his partner with a dazzling holographic display that projected personalised messages, photos of their relationship, and a floating virtual ring before he got down on one knee with the real thing.</p>
    <p>The proposal was reportedly planned for months with the help of a local tech startup specialising in experiential events. The startup has since reported a flood of enquiries from couples wanting to replicate the experience.</p>
    <p>The couple have been flooded with messages of congratulations from around the world, saying they never expected their private moment to become a global phenomenon.</p>`,
    category: "Viral",
    imageUrl: "https://picsum.photos/seed/viral1/800/450",
    author: "Blessing Osei",
    authorAvatar: "https://picsum.photos/seed/author7/80/80",
    timestamp: new Date("2026-06-15T07:00:00"),
    views: 89200,
    trending: true,
    viral: true,
  },
  {
    id: "8",
    title: "Central Bank Raises Interest Rates Amid Inflation Concerns",
    slug: "central-bank-raises-interest-rates",
    excerpt: "Policymakers announce a significant rate hike as inflation hits a five-year high, raising concerns among mortgage holders and small businesses.",
    content: `<p>Policymakers have announced a significant interest rate hike as inflation reaches a five-year high, raising concerns among mortgage holders, small businesses, and ordinary consumers already feeling the pinch.</p>
    <p>The central bank's decision to raise rates by 1.5 percentage points was widely anticipated by analysts but has still sent shockwaves through financial markets, with the stock exchange dropping sharply on the news.</p>
    <p>Economists are divided on whether the move will effectively curb inflation or simply dampen economic growth at a critical time. Consumer groups have warned that millions of families will struggle with higher borrowing costs.</p>
    <p>The governor of the central bank defended the decision in a press conference, insisting that controlling inflation is paramount to long-term economic stability and prosperity.</p>`,
    category: "Business",
    imageUrl: "https://picsum.photos/seed/business2/800/450",
    author: "Kunle Fashola",
    authorAvatar: "https://picsum.photos/seed/author8/80/80",
    timestamp: new Date("2026-06-09T16:00:00"),
    views: 11200,
    trending: false,
    viral: false,
  },
  {
    id: "9",
    title: "Local Football Club Upsets Champions in Cup Shock",
    slug: "local-club-upsets-champions-cup",
    excerpt: "A minnow club stuns the reigning champions in a stunning cup upset, proving once again that anything can happen in football.",
    content: `<p>In one of the biggest upsets of the season, a little-known local club stunned the reigning champions with a composed and disciplined performance to advance to the next round of the national cup.</p>
    <p>The match, played on a muddy pitch in front of a passionate home crowd, saw the underdogs take the lead early and defend heroically to preserve their shock victory.</p>
    <p>The club's manager called it the greatest day in the club's history, dedicating the win to the local community that has supported them through difficult financial times.</p>
    <p>Social media erupted with celebrations from fans of the smaller club, while pundits debated how the champions would respond to such an embarrassing exit from the competition.</p>`,
    category: "Sports",
    imageUrl: "https://picsum.photos/seed/sports2/800/450",
    author: "Emeka Nwosu",
    authorAvatar: "https://picsum.photos/seed/author3/80/80",
    timestamp: new Date("2026-06-08T20:00:00"),
    views: 19700,
    trending: false,
    viral: true,
  },
  {
    id: "10",
    title: "AI Assistant Passes Medical Licensing Exam With Top Marks",
    slug: "ai-assistant-passes-medical-exam",
    excerpt: "A new artificial intelligence system has outperformed human candidates in a prestigious medical licensing examination, reigniting debates about the future of healthcare.",
    content: `<p>A new artificial intelligence system has outperformed the majority of human candidates in a prestigious medical licensing examination, scoring in the top tier and reigniting fierce debates about the future of healthcare and professional practice.</p>
    <p>The AI, developed by a research consortium, demonstrated exceptional ability in clinical reasoning, diagnosis, and treatment planning across a broad range of medical scenarios.</p>
    <p>Medical professionals have reacted with a mixture of awe and concern. While many acknowledge the potential of AI to support diagnosis and reduce errors, others worry about liability, ethical decision-making, and the risk of over-reliance on machines.</p>
    <p>Regulatory bodies are now being called to develop frameworks for how AI tools can be safely and responsibly integrated into clinical practice, balancing innovation with patient safety.</p>`,
    category: "Technology",
    imageUrl: "https://picsum.photos/seed/tech2/800/450",
    author: "Tunde Adeyemi",
    authorAvatar: "https://picsum.photos/seed/author4/80/80",
    timestamp: new Date("2026-06-07T13:00:00"),
    views: 22100,
    trending: true,
    viral: false,
  },
  {
    id: "11",
    title: "Celebrity Chef Opens Restaurant in Abuja, Tables Fully Booked",
    slug: "celebrity-chef-opens-abuja-restaurant",
    excerpt: "The acclaimed chef's newest venture has already caused a storm, with reservations filled up three months in advance within hours of opening.",
    content: `<p>Acclaimed celebrity chef has opened his latest restaurant in the heart of Abuja, and demand has been extraordinary — tables were fully booked three months in advance within hours of reservations going live.</p>
    <p>The restaurant blends traditional West African culinary techniques with contemporary fine dining, drawing on a menu that celebrates local ingredients and seasonal produce sourced directly from Nigerian farms.</p>
    <p>Food critics who attended the soft opening were lavish in their praise, with several calling it the most exciting restaurant to open in the country in years. The ambience, combining art from local sculptors and musicians, drew particular acclaim.</p>
    <p>The chef says he hopes the restaurant will become a showcase for the richness and diversity of African cuisine on a global stage, and plans to open further locations internationally in the coming year.</p>`,
    category: "Entertainment",
    imageUrl: "https://picsum.photos/seed/entertain2/800/450",
    author: "Amaka Eze",
    authorAvatar: "https://picsum.photos/seed/author2/80/80",
    timestamp: new Date("2026-06-06T12:00:00"),
    views: 8900,
    trending: false,
    viral: false,
  },
  {
    id: "12",
    title: "Government Launches Free WiFi Initiative Across Public Spaces",
    slug: "government-free-wifi-initiative",
    excerpt: "A bold new digital inclusion policy promises free broadband access in parks, markets, bus stops and government buildings across the country.",
    content: `<p>The government has launched an ambitious free WiFi initiative that promises to provide broadband internet access at thousands of public spaces across the country, including parks, markets, bus terminals, and government buildings.</p>
    <p>The initiative is part of a broader digital inclusion strategy aimed at ensuring that all citizens, regardless of economic status, can access the internet and benefit from the digital economy.</p>
    <p>Telecommunications companies partnering on the project say the infrastructure rollout will take 18 months to complete, with pilot sites in major cities already going live this month.</p>
    <p>Digital rights advocates have broadly welcomed the move but are pressing the government for clear policies on data privacy and transparency around how user data collected through the network will be handled.</p>`,
    category: "Politics",
    imageUrl: "https://picsum.photos/seed/politics2/800/450",
    author: "Chidi Okonkwo",
    authorAvatar: "https://picsum.photos/seed/author1/80/80",
    timestamp: new Date("2026-06-05T10:00:00"),
    views: 13500,
    trending: false,
    viral: false,
  },
];
